import R from 'ramda'

export const getErrorCode = R.path(['response', 'body', 'errors', 0, 'code'])

export const errorCodes = {
  EMAIL_ALREADY_EXISTS: 13,
  RESET_USER_DOESNT_EXIST: 15,
  INSUFFICIENT_PASSWORD_STRENGTH_NO_DIGIT: 21,
  INSUFFICIENT_PASSWORD_STRENGTH_NO_UPPERCASE: 21,
  PASSWORD_WRONG: 23, // returned by PUT on /email
  PASSWORD_DOES_NOT_MATCH: 32, // returned by PUT on /password
}
